//moment(new Date()).format("Do MMMM")
export const applicationAction = (application) => {
    return (dispatch, getState, { getFirebase }) => {
      const firestore = getFirebase().firestore();
      //console.log(application);
      firestore
        .collection("applications")
        .add(
          application
        )
        .then(() => {
          dispatch({
            type: "ADD_APPLICATION",
            success: true
          });
        })
        .catch((err) => {
          dispatch({
            type: "ADD_APPLICATION_ERR",
            err
          });
        });
    };
  };
  